import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from './SessionDialog'

const TextArea = styled.textarea`
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
  &:focus {
    outline: 2px solid ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    outline-offset: 1px;
  }
`

export default function CancelDialog({ open, session, onClose, onSubmit }) {
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  if (!session) return null

  async function handleSubmit() {
    setBusy(true)
    try {
      await onSubmit({ reason: reason.trim() || null })
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title="Cancel session"
      subtitle={`Cancelling will let ${session.practitionerName} know. You can rebook any time.`}
      primaryLabel="Cancel session"
      primaryTone="urgent"
      onPrimary={handleSubmit}
      primaryLoading={busy}
      onClose={onClose}
    >
      <TextArea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Optional: a quick note for your practitioner"
      />
    </SessionDialog>
  )
}
